import React from "react";
import { Button, Dialog, DialogActions, DialogContent } from "@mui/material";

type MyLeaveConfirmDialogProps = {
  showDialog: boolean;
  closeDialog: () => void;
  onConfirm: () => void;
  title: React.ReactNode;
  text: React.ReactNode;
  confirmLabel: React.ReactNode;
  cancelLabel: React.ReactNode;
  isMobile: boolean;
};

export const MyLeaveConfirmDialog = ({
  showDialog,
  closeDialog,
  onConfirm,
  title,
  text,
  confirmLabel,
  cancelLabel,
  isMobile
}: MyLeaveConfirmDialogProps) => {
  const handleCancel = () => {
    closeDialog();
  };

  const handleConfirm = () => {
    closeDialog();
    onConfirm();
  };

  return (
    <Dialog
      aria-labelledby="new-request-dialog-title"
      open={showDialog}
      //disableBackdropClick
      onClose={(event, reason) => {
        if (reason !== "backdropClick") {
          return false;
        }
      }}
      disableEscapeKeyDown
      scroll="body"
      PaperProps={{
        style: { padding: "0px 24px 24px 24px", width: isMobile ? "auto" : 528 },
      }}
    >
      <div
        style={{
          paddingTop: 24,
          paddingBottom: 12,
          paddingLeft: 0,
          paddingRight: 0,
          textAlign: "center",
          fontSize: 24,
          fontFamily: "Mulish",
        }}
      >
        {title}
      </div>
      <DialogContent>
        <div style={{ textAlign: "center", padding: 30 }}>
          <span
            style={{
              fontFamily: "Mulish",
              fontSize: "16px",
              letterSpacing: 0.44,
            }}
          >
            {text}
          </span>
        </div>
      </DialogContent>
      <DialogActions>
        <div
          style={{
            width: "100%",
            display: "flex",
            flexDirection: "column",
          }}
        >
          <Button
            id="my-leave-confirm-dialog-delete-button"
            fullWidth
            variant="contained"
            color="primary"
            disableElevation
            onClick={handleConfirm}
            style={{ marginBottom: 44 }}
          >
            {confirmLabel}
          </Button>
          <Button
            fullWidth
            color="secondary"
            variant="text"
            onClick={handleCancel}
          >
            {cancelLabel}
          </Button>
        </div>
      </DialogActions>
    </Dialog>
  );
};

export default MyLeaveConfirmDialog;
